import {AxiosError} from "axios"
import {waitPromise} from "@irati/utils/promise"
import {PLATFORM} from "@irati-web/app/src/routeConfig"
import History from "../../../../history"
import isMaintenance from "./isMaintenance"

export default function (err: AxiosError) {
  if (isMaintenance(err)) {
    waitPromise()
      .then(() => {
        // every failing request triggers this, only push once so back doesn't land on /maintenance again
        if (window.location.pathname.endsWith("/maintenance")) {
          return
        }
        History.push({
          pathname: "/maintenance",
          app: PLATFORM
        })
      })
      .catch((e) => console.log(e))
  }
}
